import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api-service';

import { notification } from 'antd';
import { WorkPolicy } from 'src/types/common.types';

const fetchData = async () => {
  const response = await ApiService.get<WorkPolicy[]>('/api/workers/work_policies');
  const data = response.data;
  if (response.status !== 200) {
    notification.error({
      message: 'Không thể lấy chính sách công',
    });
    return [];
  }
  return data;
};

const useWorkPolicies = () => {
  return useQuery({
    queryKey: ['work-policies'],
    queryFn: fetchData,
    staleTime: 1000 * 60 * 5,
  });
};

export default useWorkPolicies;
